import { render } from "./SimpleTile.vue?vue&type=template&id=6d3c6d1c&scoped=true"
import script from "./SimpleTile.vue?vue&type=script&lang=js"
export * from "./SimpleTile.vue?vue&type=script&lang=js"

import "./SimpleTile.vue?vue&type=style&index=0&id=6d3c6d1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3c6d1c"]])

export default __exports__